import { z } from 'zod';

export const idSchema = z.coerce.number().int().positive();
export const idParamsSchema = z.object({ id: idSchema });

export const apiErrorSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
  }),
});
export type ApiErrorBody = z.infer<typeof apiErrorSchema>;
